import dashboardController from "@/services/dashboardService";
import { getUserLogin } from "@/utils/auth";

export default {
  name: "DashboardView",

  data() {
    return {
      documentSummary: {
        total_document: 0,
        active: 0,
        expired: 0,
        superseded: 0,
        soon_expired: 0,
      },
      assetLaptopSummary: {
        total_asset: 0,
        active: 0,
        expired: 0,
        soon_expired: 0,
      },
      assetInfraSummary: {
        total_asset: 0,
        active: 0,
        expired: 0,
        soon_expired: 0,
      },
      penawaranSummary: {
        total: 0,
        active: 0,
        expired: 0,
        soon_expired: 0,
      },
      expiringList: [],
    };
  },

  computed: {
    isAdmin() {
      const user = getUserLogin() || {};
      return (
        Number(user.group_id) === 1 ||
        (user.group_name || "").toLowerCase().includes("admin")
      );
    },
    userDivisionId() {
      const user = getUserLogin() || {};
      return user.mst_division_id != null ? Number(user.mst_division_id) : null;
    },
    canViewDocument() {
      return this.isAdmin || [3, 4, 6].includes(this.userDivisionId);
    },
    canViewOffer() {
      return this.isAdmin || [3, 4, 6].includes(this.userDivisionId);
    },
    canViewAsset() {
      return this.isAdmin || this.userDivisionId === 7;
    },
    documentBars() {
      const total = this.documentSummary.total_document || 1;
      return [
        {
          label: "Active",
          value: this.documentSummary.active,
          percent: Math.min(
            100,
            Math.round((this.documentSummary.active / total) * 100),
          ),
          colorClass: "bg-active",
        },
        {
          label: "Expired",
          value: this.documentSummary.expired,
          percent: Math.min(
            100,
            Math.round((this.documentSummary.expired / total) * 100),
          ),
          colorClass: "bg-expired",
        },
        {
          label: "Superseded",
          value: this.documentSummary.superseded,
          percent: Math.min(
            100,
            Math.round((this.documentSummary.superseded / total) * 100),
          ),
          colorClass: "bg-superseded",
        },
        {
          label: "Soon Expired (H-60)",
          value: this.documentSummary.soon_expired,
          percent: Math.min(
            100,
            Math.round((this.documentSummary.soon_expired / total) * 100),
          ),
          colorClass: "bg-soon",
        },
      ];
    },
    assetLaptopBars() {
      const total = this.assetLaptopSummary.total_asset || 1;
      return [
        {
          label: "Active",
          value: this.assetLaptopSummary.active,
          percent: Math.min(
            100,
            Math.round((this.assetLaptopSummary.active / total) * 100),
          ),
          colorClass: "bg-active",
        },
        {
          label: "Inactive / Retired",
          value: this.assetLaptopSummary.expired,
          percent: Math.min(
            100,
            Math.round((this.assetLaptopSummary.expired / total) * 100),
          ),
          colorClass: "bg-expired",
        },
      ];
    },
    assetInfraBars() {
      const total = this.assetInfraSummary.total_asset || 1;
      return [
        {
          label: "Active",
          value: this.assetInfraSummary.active,
          percent: Math.min(
            100,
            Math.round((this.assetInfraSummary.active / total) * 100),
          ),
          colorClass: "bg-active",
        },
        {
          label: "Expired",
          value: this.assetInfraSummary.expired,
          percent: Math.min(
            100,
            Math.round((this.assetInfraSummary.expired / total) * 100),
          ),
          colorClass: "bg-expired",
        },
        {
          label: "Soon Expired (H-60)",
          value: this.assetInfraSummary.soon_expired,
          percent: Math.min(
            100,
            Math.round((this.assetInfraSummary.soon_expired / total) * 100),
          ),
          colorClass: "bg-soon",
        },
      ];
    },
    penawaranBars() {
      const total = this.penawaranSummary.total || 1;
      return [
        {
          label: "Active",
          value: this.penawaranSummary.active,
          percent: Math.min(
            100,
            Math.round((this.penawaranSummary.active / total) * 100),
          ),
          colorClass: "bg-active",
        },
        {
          label: "Expired",
          value: this.penawaranSummary.expired,
          percent: Math.min(
            100,
            Math.round((this.penawaranSummary.expired / total) * 100),
          ),
          colorClass: "bg-expired",
        },
        {
          label: "Soon Expired (H-60)",
          value: this.penawaranSummary.soon_expired,
          percent: Math.min(
            100,
            Math.round((this.penawaranSummary.soon_expired / total) * 100),
          ),
          colorClass: "bg-soon",
        },
      ];
    },
  },

  methods: {
    async loadDashboard() {
      try {
        const res = await dashboardController.getSummary();
        this.documentSummary = res.document || this.documentSummary;
        this.assetLaptopSummary = res.asset_laptop || this.assetLaptopSummary;
        this.assetInfraSummary = res.asset_infra || this.assetInfraSummary;
        this.penawaranSummary = res.penawaran || this.penawaranSummary;
        this.expiringList = res.expiringList || [];
      } catch (error) {
        console.error(error);
      }
    },
  },

  mounted() {
    this.loadDashboard();
  },
};